module.exports = "/img/_/_/_/assets/images/creeper/book/rare//2.jpg?b02ac6c2e63706896b4ea3aadadafcdd";